module.exports = __webpack_public_path__ + "static/media/email-out.930b8d19.svg";